import { __ } from '../i18n';

const DAY_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

const DAY_LABELS = {
	mon: __('Monday', 'dealer-locator'),
	tue: __('Tuesday', 'dealer-locator'),
	wed: __('Wednesday', 'dealer-locator'),
	thu: __('Thursday', 'dealer-locator'),
	fri: __('Friday', 'dealer-locator'),
	sat: __('Saturday', 'dealer-locator'),
	sun: __('Sunday', 'dealer-locator'),
};

// "09:00" -> "9:00 AM", "18:30" -> "6:30 PM"
export function formatTime12h(hhmm) {
	if (!hhmm) return '';
	const [h, m] = hhmm.split(':').map(Number);
	const period = h >= 12 ? 'PM' : 'AM';
	const hour12 = h % 12 === 0 ? 12 : h % 12;
	return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
}

function dayText(day) {
	if (!day) return null;
	if (day.is_closed) return __('Closed', 'dealer-locator');
	if (day.is_24h) return __('Open 24 hours', 'dealer-locator');
	if (day.open && day.close) return `${formatTime12h(day.open)} - ${formatTime12h(day.close)}`;
	return null;
}

// group "Monday - Friday: 09:00 AM - 06:00 PM"
export function groupWorkingHours(hours) {
	if (!hours) return [];

	const groups = [];
	let current = null;

	DAY_ORDER.forEach((key) => {
		const text = dayText(hours[key]);

		// skip without schedules
		if (!text) {
			if (current) {
				groups.push(current);
				current = null;
			}
			return;
		}

		if (current && current.text === text) {
			current.to = key;
		} else {
			if (current) groups.push(current);
			current = { from: key, to: key, text };
		}
	});

	if (current) groups.push(current);

	return groups.map((g) => ({
		label: g.from === g.to
			? DAY_LABELS[g.from]
			: `${DAY_LABELS[g.from]} - ${DAY_LABELS[g.to]}`,
		text: g.text,
	}));
}
